import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InjectableSuperclass } from '@sama/ng-core';
import {
  DetailedMessage,
  DetailedMessageComponent,
} from './detailed-message/detailed-message.component';

@Injectable({ providedIn: 'root' })
export class MessagingService extends InjectableSuperclass {
  constructor(private snackBar: MatSnackBar) {
    super();
  }

  show(message: string, duration = 3000) {
    console.log(message);
    this.snackBar.open(message, undefined, {
      panelClass: 'snack-bar',
      duration,
    });
  }

  success(message: string, duration = 3000) {
    this.snackBar.open(message, undefined, {
      panelClass: ['snack-bar', 'snack-bar-success'],
      duration,
    });
  }

  showGenericError() {
    this.error(`There was an unexpected error. (${new Date().toISOString()})`);
  }

  error(message: string, details?: string[]) {
    const data: DetailedMessage = {
      message,
      details,
    };
    return this.snackBar.openFromComponent(DetailedMessageComponent, {
      data,
      panelClass: ['snack-bar', 'snack-bar-error'],
    });
  }
}
